import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
import { Erase } from '@carbon/icons-react';
import { Select, Button } from 'antd';
import { bindActionCreators } from 'redux';
import DateRangePicker from '../../../components/DateRangePicker';
import { connect } from 'react-redux';
import { formatEventTypes } from '../../../core/utils/functions';
import * as assetActions from '../../../core/asset/assetActions';
import PropTypes from 'prop-types';

const { REGEX_VALID_UK_POSTCODE, REGEX_VALID_NUMBER } = require('../../../core/constants').default;

class DriverEventHistoryFilterForm extends Component {
    constructor(props) {
        super(props);
        let currentDriverFilters = null;
        if (props?.driverViewEventFilters?.length) {
            const matches = props.driverViewEventFilters.filter(f => parseInt(f.driverId) === parseInt(props.driverId));
            if (matches?.length) {
                currentDriverFilters = matches[0]?.filters;
            }
        }
        this.state = { currentDriverFilters };
    }

    componentDidMount() {
        const { actions } = this.props;

        actions.getEventTypesRequest();
    }

    componentDidUpdate(prevProps) {
        const { driverViewEventFilters, driverId } = this.props;
        
        if (prevProps.driverViewEventFilters !== driverViewEventFilters) {
            let currentDriverFilters = null;
            if (driverViewEventFilters?.length) {
                const matches = driverViewEventFilters.filter(f => parseInt(f.driverId) === parseInt(driverId));
                if (matches?.length) {
                    currentDriverFilters = matches[0]?.filters;
                }
            }
            this.setState({ currentDriverFilters });
        }
    }

    submitForm = (e) => {
        const { onSubmit } = this.props;

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                onSubmit(values);
            }
        });
    };

    render() {
        const { form, event_types, telematicsRetentionDays } = this.props;
        const { currentDriverFilters } = this.state;
        
        const { getFieldDecorator, getFieldValue } = form;
        const updatedEventTypes = formatEventTypes(event_types);

        return (
            <Form 
                onSubmit={this.submitForm} 
                layout="vertical"
            >
                <DateRangePicker
                    getFieldDecorator={getFieldDecorator}
                    getFieldValue={getFieldValue}
                    minDate={dayjs().subtract(telematicsRetentionDays, 'days')}
                    dateFromInitialValue={dayjs(currentDriverFilters?.date_from) || dayjs()}
                    dateToInitialValue={dayjs(currentDriverFilters?.date_to) || dayjs()}
                    dataTestId='driver-details-event-filter_date-range-picker'
                />
                <Form.Item label="Event type">
                    {getFieldDecorator('event_type', { initialValue: currentDriverFilters?.event_type || 'all' })(
                        <Select
                            placeholder="Select Event Type"
                            allowClear={<Erase size={12} />}
                            showSearch
                            filterOption={(txt, obj) => obj.props.children.toLowerCase().includes(txt.toLowerCase())}
                            data-testid='driver-details-event-filter_event-type-select'
                        >
                            <Select.Option value="all">All</Select.Option>
                            {updatedEventTypes.map((eventType, i) => (
                                <Select.Option 
                                    key={`event-type-${i}`} 
                                    value={eventType.id}
                                >
                                    {eventType.key}
                                </Select.Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>
                <div className="mt-2 mb-1 text-center">
                    <Button 
                        htmlType="submit" 
                        type="primary"
                        data-testid='driver-details-event-filter_filter-btn'
                    >
                        Filter
                    </Button>
                </div>
            </Form>
        );
    }
}

const DriverEventHistory = Form.create({ name: 'event_filter_form' })(DriverEventHistoryFilterForm);

DriverEventHistoryFilterForm.propTypes = {
    driverId: PropTypes.number,
    driverViewEventFilters: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        event_types: state.asset.event_types,
        driverList: state.driver.driverList,
        telematicsRetentionDays: state.user.userCompany.telematics_retention_days,
        driverViewEventFilters: state.driver.driverViewEventFilters,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
                ...assetActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DriverEventHistory);
